import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// are preserved — the factory returns them closed over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    ecllipseImage: index => ({
      position: 'absolute',
      top: 0,
      right: 0,
      left: index % 2 == 0 ? undefined : 0,
      height: '100%',
      width: '75%',
    }),
    centerImage: height => ({
      width: height * 0.32,
      height: height * 0.32,
    }),
    smallImage: height => ({
      width: height * 0.16,
      height: height * 0.16,
    }),
    verticalContainer: {
      justifyContent: 'space-evenly',
      alignItems: 'center',
    },
    horizontalContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    logoContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      width: 60,
      height: 60,
    },
    cardText: {
      alignItems: 'center',
      paddingHorizontal: 24,
      flex: 1,
      justifyContent: 'center',
    },
    headline: {
      fontSize: 18,
      fontFamily: FONTS.boldFont,
      color: colors.link,
    },
    subtitle: {
      color: colors.textMuted,
      lineHeight: 21,
      fontSize: 14,
      fontFamily: FONTS.regularFont,
      textAlign: 'center',
    },
    marginTop16: {
      marginTop: 16,
    },
    logoImage: {
      width: 40,
      height: 40,
      resizeMode: 'contain',
    },
    spaceEven: (height, width) => ({
      justifyContent: 'space-evenly',
      width: width / 2,
      height: height,
    }),
  });

export default makeStyles;
